import React from 'react'
import { useJiekuanlxDelMutation } from '../../../store/DianShangYeWuApi'
import Icon from '../../../cpn/Icon';
import { App } from 'antd'
function LoanTypeDel(props) {
    const {message} = App.useApp()
    const [submitDel] = useJiekuanlxDelMutation()
    return (
        <Icon type='delete' 
            onClick={() => {
                submitDel({
                    jklx_id:props.jklx_id,
                }).then((res) => {
                    if (res.data.Status === 'success') {
                        message.info('删除成功');
                    }
                    if (res.data.Status === "fail") {
                        message.error('删除失败：'+res.data.Message)
                    }
                })
            }}
        > </Icon>
    )
    }

export default LoanTypeDel